import React, { createContext, useContext, useState, useEffect } from 'react'
import { getSiteConfig } from '../services/api'

// 创建配置上下文
const ConfigContext = createContext()

// 配置提供者组件
export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null)
  const [loading, setLoading] = useState(true)
  const [lastUpdated, setLastUpdated] = useState(null)

  // 加载配置
  const loadConfig = async () => {
    try {
      setLoading(true)
      const data = await getSiteConfig()
      setConfig(data)
      setLastUpdated(new Date())
      console.log('配置已更新:', new Date().toLocaleString())
    } catch (error) {
      console.error('加载配置失败:', error)
        // 使用默认配置
        setConfig({
          identity: {
            site_name: '无锡市摩恒科技有限公司',
            logo_pc: '/uploads/logo/logo-pc.png',
            logo_mobile: '/uploads/logo/logo-mobile.png',
            footer_logo_pc: '/uploads/logo/footer-logo-pc.png',
            footer_logo_mobile: '/uploads/logo/footer-logo-mobile.png',
            favicon: '/uploads/logo/favicon.ico',
            site_domain: 'www.wxmhkj.cn',
            ssl_certificate: 'wxmhkj.cn',
            ssl_expiry_date: '2025-12-31'
          },
          copyright: {
            copyright_text: '© 2025 无锡市摩恒科技有限公司 版权所有',
            icp_number: '苏ICP备XXXXXX号',
            police_record_number: '苏公网安备 XXXXXXXX号',
            icp_link: 'https://beian.miit.gov.cn',
            police_record_link: 'http://www.beian.gov.cn',
            icp_icon: '/uploads/logo/icp-icon.png',
            police_icon: '/uploads/logo/police-icon.png',
            show_icp: true,
            show_police: true
          },
          site: {
            name: '无锡市摩恒科技有限公司',
            description: '专业科技解决方案提供商',
            keywords: '科技,解决方案,无锡,摩恒',
            contact_email: 'info@mohengtech.com',
            contact_phone: '0510-XXXXXXX',
            company_address: '江苏省无锡市'
          }
        })
    } finally {
      setLoading(false)
    }
  }

  // 刷新配置
  const refreshConfig = async () => {
    await loadConfig()
  }

  // 初始化加载配置
  useEffect(() => {
    loadConfig()
  }, [])

  // 监听配置更新事件
  useEffect(() => {
    const handleConfigUpdated = () => {
      console.log('收到配置更新事件，重新加载配置...')
      loadConfig()
    }

    // 监听自定义事件
    window.addEventListener('configUpdated', handleConfigUpdated)

    return () => {
      window.removeEventListener('configUpdated', handleConfigUpdated)
    }
  }, [])

  // 定期检查配置更新（每30秒）
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!loading && config) {
        // 可以在这里添加逻辑检查配置是否有更新
        // 例如，可以调用一个API检查配置的最后更新时间
        console.log('定期检查配置更新...')
      }
    }, 30000) // 30秒

    return () => {
      clearInterval(intervalId)
    }
  }, [loading, config])

  return (
    <ConfigContext.Provider value={{ 
      config, 
      loading, 
      refreshConfig,
      lastUpdated 
    }}>
      {children}
    </ConfigContext.Provider>
  )
}

// 自定义钩子
export const useConfig = () => {
  const context = useContext(ConfigContext)
  if (!context) {
    throw new Error('useConfig必须在ConfigProvider内部使用')
  }
  return context
}

// 触发配置更新事件（可以从任何地方调用）
export const triggerConfigUpdate = () => {
  console.log('触发配置更新事件')
  window.dispatchEvent(new CustomEvent('configUpdated'))
}
